import { APP_BASE_HREF, KeyValue, NgClass }                                                                                        from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, effect, EventEmitter, Inject, inject, input, Input, OnInit, Output, signal } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, ReactiveFormsModule, ValidationErrors } from '@angular/forms';
import { MatAutocomplete, MatAutocompleteModule, MatOption }                                                                       from '@angular/material/autocomplete';
import { MatIconButton }                                                                                                           from '@angular/material/button';
import { ErrorStateMatcher }                                                                                                       from '@angular/material/core';
import { MatDatepicker, MatDatepickerInput }                                                                                       from '@angular/material/datepicker';
import { MatIcon, MatIconModule }                                                                                                  from '@angular/material/icon';
import { MatError, MatFormField, MatInputModule }                                                                                  from '@angular/material/input';
import { MatSelect }                                                                                                               from '@angular/material/select';
import { MatTooltip }                                                                                                              from '@angular/material/tooltip';
import { ActivatedRoute }                                                                                                          from '@angular/router';
import { UntilDestroy, untilDestroyed }                                                                                            from '@ngneat/until-destroy';
import { LetDirective }                                                                                                            from '@ngrx/component';
import { Store }                                                                                                                   from '@ngrx/store';
import { Profession }                                                                                                              from '@shared/classes/profession';
import { User }                                                                                                                    from '@shared/classes/user';
import { FORMAT_TO, FormatDateEnum, TypeDateEnum }                                                                                 from '@shared/enums/date.enum';
import { EnumOuiNon }                                                                                                              from '@shared/enums/enumOuiNon';
import { ProfilEnum }                                                                                                              from '@shared/enums/profil.enum';
import { TypeProjetEnum }                                                                                                          from '@shared/enums/typeProjetEnum';
import { YesNoEnum }                                                                                                               from '@shared/enums/yesNo.enum';
import { format, getAge, substract }                                                                                               from '@shared/helper/DateHelper';
import { isNotNull, isNull, omit }                                                                                                 from '@shared/helper/LDHelper';
import { AdresseInterface }                                                                                                        from '@shared/interface/adresse.interface';
import { IVilleInterface }                                                                                                         from '@shared/interface/IVilleInterface';
import { NgxMaskDirective, provideNgxMask }                                                                                        from 'ngx-mask';
import { BehaviorSubject, first, Observable }                                                                                      from 'rxjs';
import { debounceTime, filter, map, switchMap, take, tap, withLatestFrom }                                                         from 'rxjs/operators';
import { HelperMain }                                                                                                              from 'src/app/components/main/helperMain';
import { CHECK_STEP_ONE }                                                                                                          from 'src/app/components/main/main.constants';
import { OnUpdateParameters }                                                                                                      from 'src/app/components/shared/dynamic/dynamicElement/onUpdate.parameters';
import { HeaderStepIdgrcComponent }                                                                                                from 'src/app/components/shared/header-step-idgrc/header-step-idgrc.component';
import { AutocompleteSearchComponent }                                                                                             from 'src/app/shared/components/autocomplete-search/autocomplete-search.component';
import { DateNaissanceEnfantDisableComponent }                                                                                     from 'src/app/shared/components/enfants/date-naissance-enfant-disable/date-naissance-enfant-disable.component';
import { DateNaissanceEnfantComponent }                                                                                            from 'src/app/shared/components/enfants/date-naissance-enfant/date-naissance-enfant.component';
import { LoaderComponent }                                                                                                         from 'src/app/shared/components/loader/loader.component';
import { SwitchMultipleComponent }                                                                                                 from 'src/app/shared/components/switch-multiple/switch-multiple.component';
import { SwitchComponent }                                                                                                         from 'src/app/shared/components/switch/switch.component';
import { CustomValidatorsService }                                                                                                 from 'src/app/shared/errors/CustomValidatorsService';
import { ErrorsMessagesComponent }                                                                                                 from 'src/app/shared/errors/errorsMessages.components';
import { reinitBilans }                                                                                                            from 'src/app/shared/ngrx/store/actions/bilan.actions';
import { updateAdresses }                                                                                                          from 'src/app/shared/ngrx/store/actions/config.actions';
import { reinitStateUser }                                                                                                         from 'src/app/shared/ngrx/store/actions/user.actions';
import { selectAdresses, selectProfessions }                                                                                       from 'src/app/shared/ngrx/store/selectors/config.selector';
import { selectStateUser, selectUser }                                                                                             from 'src/app/shared/ngrx/store/selectors/user.selector';
import { IAppState }                                                                                                               from 'src/app/shared/ngrx/store/state/app.state';
import { CheckControlPipe }                                                                                                        from 'src/app/shared/pipe/checkControl.pipe';
import { CheckOAVPipe }                                                                                                            from 'src/app/shared/pipe/checkOAV.pipe';
import { ArrayNotNullPipePipe }                                                                                                    from 'src/app/shared/pipe/shared/arrayNotNull.pipe';
import { ClassErrorPipePipe }                                                                                                      from 'src/app/shared/pipe/shared/classError.pipe';
import { ShowInfoPipePipe }                                                                                                        from 'src/app/shared/pipe/showInfoDateNaissance.pipe';
import { QueryParams }                                                                                                             from 'src/app/shared/queryParams/queryParams';
import { TechnicalService }                                                                                                        from 'src/app/shared/services/technical.service';
import { KEY_STORAGE, LocalStorageUtil }                                                                                           from 'src/app/shared/utils/localStorageUtil';
import { StatutBilan }                                                                                                             from '../StatutBilan';
import { StepOneHelper }                                                                                                           from './step-one.helper';
import { FORM, TITLES_EMPRUNT, TOOLTIP }                                                                                           from './stepOne.constants';

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    return control.touched && control && control.invalid;
  }
}

@UntilDestroy ()
@Component ({
              selector:    'app-step-one',
              templateUrl: './step-one.component.html',
              styleUrls:   ['./step-one.component.scss'],
              standalone:  true,
              imports: [
                ReactiveFormsModule,
                SwitchComponent,
                MatInputModule,
                NgClass,
                ErrorsMessagesComponent,
                CheckControlPipe,
                CheckOAVPipe,
                MatIconModule,
                SwitchMultipleComponent,
                DateNaissanceEnfantComponent,
                DateNaissanceEnfantDisableComponent,
                AutocompleteSearchComponent,
                MatAutocompleteModule,
                MatFormField,
                MatAutocomplete,
                MatOption,
                MatError,
                MatIcon,
                MatDatepicker,
                ClassErrorPipePipe,
                MatDatepickerInput,
                MatSelect,
                MatTooltip,
                LoaderComponent,
                ArrayNotNullPipePipe,
                NgxMaskDirective,
                MatIconButton,
                LetDirective,
                HeaderStepIdgrcComponent,
                ShowInfoPipePipe,
              ],
              providers:   [
                provideNgxMask (),
              ],
            })
export class StepOneComponent implements OnInit, AfterViewInit {
  public isOAV                 = false;
  public formGroup: FormGroup;
  public maxDate               = substract (TypeDateEnum.YEARS, 18);
  public tooptip               = TOOLTIP;
  public titlesEmprunt         = TITLES_EMPRUNT;
  public matcher: ErrorStateMatcher;
  public professions$: BehaviorSubject<KeyValue<string, string>[]>;
  protected readonly YesNoEnum = YesNoEnum;
  public placeHolderProfession = 'Profession à risque';

  public sigLoadingData           = signal<boolean> (false);
  public sigDatesNaissanceEnfants = signal<string[]> (new Array<string> ());
  public sigDisableButtonCivilite = signal<string> ('NONE');
  public sigVilles                = signal<IVilleInterface[]> (new Array<IVilleInterface> ());
  public sigAdresses              = signal<AdresseInterface[]> (new Array<AdresseInterface> ());
  public sigByIdgrc               = signal<boolean> (false);
  public markAsTouched$$          = input.required<EnumOuiNon> ();

  public childDisableAll = signal<string> ('');

  public typeProjetEnum = TypeProjetEnum;

  @Input ()
  public queryParams: QueryParams;

  @Output ()
  valuesHasChanged: EventEmitter<StatutBilan>;

  public fb                = inject (FormBuilder);
  public technicalService  = inject (TechnicalService);
  public store             = inject (Store<IAppState>);
  public changeDetectorRef = inject (ChangeDetectorRef);

  public selectUser$      = this.store.select (selectUser);
  public selectStateUser$ = this.store.select (selectStateUser);

  constructor (@Inject (APP_BASE_HREF) public baseHref: string, private route: ActivatedRoute) {
    this.formGroup        = this.fb.group (FORM ());
    this.valuesHasChanged = new EventEmitter<StatutBilan> ();
    this.professions$     = new BehaviorSubject ([]);

    effect (() => {
      if (this.markAsTouched$$ () === EnumOuiNon.OUI) {
        this.formGroup.markAllAsTouched ();
        this.changeDetectorRef.markForCheck ();
      }
    });
  }

  ngOnInit (): void {
    this.route.queryParams.pipe (
      untilDestroyed (this),
      map ((m: any) => {
        if (m.PROFIL === ProfilEnum.OAV) {
          this.isOAV = true;
        }
      }),
    ).subscribe ();

    this.initFormGroup (this.queryParams.PROFIL);

    // reinit values - not in guard
    this.store.dispatch (reinitBilans ());
    this.store.dispatch (reinitStateUser ());

    // selfcare
    if (this.queryParams.PROFIL === ProfilEnum.SELFCARE) {
      this.placeHolderProfession = 'Profession';
      LocalStorageUtil.reinitKeys ([KEY_STORAGE.ACTION, KEY_STORAGE.KEY_BILAN, KEY_STORAGE.USERID]);
      this.updateListeVille ();
      this.getListAdresses ();
    }


    const _self = this;
    _self.formGroup.get ('dateDeNaissance').valueChanges.pipe (untilDestroyed (this)).subscribe ({
                                                                                                   next: (v) => {
                                                                                                     _self.updateByDateNaissance (v);
                                                                                                   },
                                                                                                 });

    _self.formGroup.valueChanges.pipe (untilDestroyed (this)).subscribe ({
                                                                           next: () => {
                                                                             _self.onUpdate ();
                                                                           },
                                                                         });
  }

  ngAfterViewInit (): void {
    const _self = this;
    this.selectUser$.pipe (
      withLatestFrom (
        this.store.select (selectProfessions),
      ),
      debounceTime (400),
      take (1),
    ).subscribe ({

                   next: ([user, professions]: [User, Profession[]]) => {

                     // update profession
                     const profession = StepOneHelper.getProfession (_self.queryParams.PROFIL, professions, user.idProfession);
                     _self.professions$.next (StepOneHelper.getProfessionsFormatted (professions));

                     // update dt naissnace
                     const dateDeNaissance = isNotNull (user.dateDeNaissance) ? format (FormatDateEnum.FRENCH_FORMAT, FORMAT_TO.DATE, user.dateDeNaissance) : null;

                     // patch value formgroup
                     _self.formGroup.patchValue (omit ({
                                                         ...user,
                                                         profession,
                                                         dateDeNaissance,
                                                       }, ['datesNaissanceEnfants', 'enfants']), {
                                                   emitEvent: false,
                                                   onlySelf:  true,
                                                 });
                     _self.checkChildren (user);

                     _self.sigByIdgrc.set (user.byIdgrc);
                     if (user.byIdgrc) {
                       this.formGroup.get ('email').setValidators (null);
                     }

                     // update staut parent
                     const statutBilan       = new StatutBilan ();
                     statutBilan.user        = user;
                     statutBilan.queryParams = _self.queryParams;
                     statutBilan.invalid     = this.checkValid (user);
                     _self.valuesHasChanged.next (statutBilan);

                     _self.sigLoadingData.set (true);
                   },
                 });
  }

  private checkChildren (user: User) {
    this.childDisableAll.set (this.sigByIdgrc () ? 'ALL' : '');

    this.formGroup.get ('enfant').setValue (user.datesNaissanceEnfants.length > 0 ? YesNoEnum.oui : YesNoEnum.non);

    // init date naissance enfants
    this.sigDatesNaissanceEnfants.set (user.datesNaissanceEnfants);
  }

  private checkValid (user: User): boolean {
    return this.formGroup.valid ? !HelperMain.check (user, this.queryParams) : true;
  }

  protected initFormGroup (profil: ProfilEnum) {
    this.formGroup.get ('profession').setValidators ([CustomValidatorsService.requiredValidator ('de la profession')]);
    if (profil === ProfilEnum.OAV) {
      this.formGroup.get ('email').setValidators ([
                                                    CustomValidatorsService.requiredValidator ('de l\'email'),
                                                    CustomValidatorsService.emailValidator,
                                                  ]);
    } else {
      this.formGroup.get ('ville').setValidators ([CustomValidatorsService.requiredValidator ('de votre ville')]);
      this.formGroup.get ('adresse').setAsyncValidators (this.adressCodeValidator.bind (this));
      this.formGroup.get ('adresse').setValidators ([CustomValidatorsService.requiredValidator ('de votre adresse')]);
      this.formGroup.get ('email').setValidators (null);
    }
  }

  private updateByDateNaissance (dateDeNaissance: string) {
    const check = CHECK_STEP_ONE[TypeProjetEnum.EMPRUNT_IMMOBILIER_OR_PROJET_EMPRUNT];
    const age   = getAge (dateDeNaissance);
    if (!check (null, age, null)) {
      this.formGroup.patchValue ({
                                   [TypeProjetEnum.EMPRUNT_OR_PROJET_SUP_QUINZE_MILLE]:   '',
                                   [TypeProjetEnum.EMPRUNT_IMMOBILIER_OR_PROJET_EMPRUNT]: '',
                                 });
    }

  }

  onUpdate () {
    let user = User.initByDefault (this.formGroup.value);
    user.age = getAge (user.dateDeNaissance);

    // make child
    if (user.enfant == YesNoEnum.non) {
      this.sigDatesNaissanceEnfants.set (new Array<string> ());
    }
    user.datesNaissanceEnfants = this.sigDatesNaissanceEnfants ();


    const statutBilan       = new StatutBilan ();
    statutBilan.user        = user;
    statutBilan.queryParams = this.queryParams;
    statutBilan.invalid     = this.checkValid (user);
    this.valuesHasChanged.next (statutBilan);
  }

  updateProfession (donneesClient: KeyValue<string, string>) {
    this.formGroup.get ('profession').setValue (donneesClient, { emitEvent: true });
  }

  private updateListeVille () {
    this.formGroup.get ('codepostal').valueChanges.pipe (
      debounceTime (300),
      filter ((cp: string) => /^(?:0[1-9]|[1-8]\d|9[0-8])\d{3}$/.test (cp)),
      switchMap ((cp: string) => this.technicalService.getVilleByCP (cp)),
    ).subscribe ({
                   next: (values: Array<IVilleInterface>) => {
                     this.formGroup.get ('ville').setValue (null);
                     this.formGroup.get ('adresse').setValue (null);
                     this.sigVilles.set (values);
                     this.sigAdresses.set (null);
                   },
                 });
  }

  private getListAdresses () {
    this.formGroup.get ('adresse').valueChanges.pipe (
      debounceTime (500),
      filter ((value) => value !== '' && value !== undefined && typeof value === 'string'),
      tap (() => {
        this.sigAdresses.set (null);
      }),
      filter ((value) => isNotNull (this.formGroup.get ('ville')?.value)),
      switchMap ((adresse: string) => {
        return this.technicalService.getAdressesAutocomplete (this.formGroup.get ('ville')?.value?.codeInsee, adresse);
      }),
    ).subscribe ({
                   next: (adresses: Array<AdresseInterface>) => {
                     this.store.dispatch (updateAdresses ({ adresses }));
                     this.sigAdresses.set (adresses);
                   },
                 });
  }

  updateProjetEmprunt () {
    this.formGroup.patchValue ({
                                 [TypeProjetEnum.EMPRUNT_OR_PROJET_SUP_QUINZE_MILLE]: '',
                               });
  }

  displayAdresse = (a: AdresseInterface) => {
    return a ? `${a.numero} ${a.voie}` : '';
  };

  onChangeEnfants (onUpdateParameters: OnUpdateParameters) {
    this.sigDatesNaissanceEnfants.set (onUpdateParameters.value);
    this.changeDetectorRef.detectChanges ();
    this.onUpdate ();
  }

  adressCodeValidator (control: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> {
    let adresse = control.value;
    return this.store.select (selectAdresses).pipe (
      take (2), // this gets a little tricky here
    ).pipe (
      map (adresses => {
        const result = adresses.filter (v => v === adresse);
        if (result.length === 0) {
          return { 'adressIsNotValid': false };
        }
        return null;
      }),
      first (),
    );
  }

  protected readonly isNotNull = isNotNull;
  protected readonly isNull    = isNull;
}
